import React from 'react';

import OutputText from '@ey/canvascoreservices/OutputText';

export const prop = 'description';

const NameColumn = ({id, description}) => {
	const txt = `${description} (${id})`;
	const props = {
		children: txt,
		title: txt
	};

	return <OutputText body2 light {...props} ellipsis />;
};

export const config = (labels) => ({
	id: 'engagementNameColumn',
	label: labels.engagementName,
	propName: prop,
	width: '1fr',
	sortBy: prop,
	customCell: (item) => <NameColumn {...item} />
});
